import { memo } from 'react';
import { ColHeaderCell } from '@/modules/vip/ComparisonSection/components/ComparisonTable/components/ColHeaderCell';
import { SectionGroup } from '@/modules/vip/ComparisonSection/components/ComparisonTable/components/SectionGroup';
import type { IComparisonUICol, IComparisonUISection } from '../../types';
import { ScComparisonTable, ScHeaderLabelCell } from './styled';

interface IComparisonTableProps {
  cols: IComparisonUICol[];
  sections: IComparisonUISection[];
  colsTitle: string | null;
}

export const ComparisonTable = memo(
  ({ cols, sections, colsTitle }: IComparisonTableProps) => {
    const colIds = cols.map((col) => col.id);
    return (
      <ScComparisonTable>
        <ScHeaderLabelCell>{colsTitle}</ScHeaderLabelCell>
        {cols.map((col, i) => (
          <ColHeaderCell col={col} index={i} key={col.id} />
        ))}
        {sections.map((section) => (
          <SectionGroup colIds={colIds} key={section.id} section={section} />
        ))}
      </ScComparisonTable>
    );
  }
);

ComparisonTable.displayName = 'ComparisonTable';
